/**
 * PRODUCT-SPECIFICATIONS MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 *
 * Per-SKU specification sheets (the source app "Product Specs" workbook,
 * brought into Brand Command). Ties 1:1 to the Product SKUs in System Settings
 * via shared/productSpecsService — editing here also edits the SKU. Includes a
 * branded .xlsx export (company colors + logo).
 *
 * Public entry. Registered in App.jsx via
 * registerModule(productSpecificationsRoutes, { roles: ['admin','user'] }).
 */
import ProductSpecifications from "./routes/ProductSpecifications.jsx";

export const productSpecificationsRoutes = [
  { path: "/product-specs", component: ProductSpecifications },
];

// Listed on the support ticket form's "Area" dropdown (collected automatically).
export const moduleMeta = { key: "product-specifications", label: "Product Specifications" };
